import { FC, useState } from 'react';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';
import { JourneysSelect } from './JourneysSelect';
import { Stack } from '@mui/material';
import { graphql } from '../../../../../gql';
import { useApiMutation } from '../../../../../query/hooks';
import { determineArrayUpdateOperation } from '../../../../../utils/determineArrayUpdateOperation';
import { mutationResponseHandler } from '../../../../../utils/mutationResponseHandler';
import { useIntl } from 'react-intl';
import { useSnackbar } from '../../../../../store/snackbar';

const connectJourneyToActivity = graphql(`
	mutation connectJourneyToActivity($activityId: UUID!, $data: ActivityUpdateInput!) {
		updateActivity(by: { id: $activityId }, data: $data) {
			ok
			errorMessage
		}
	}
`);

export const ConnectedJourneysCell: FC<WidgetProps> = ({ activityId, activityName, widget: { connectedJourneys } }) => {
	const intl = useIntl();
	const { mutateAsync: connectJourneyToActivityAsync } = useApiMutation(connectJourneyToActivity);
	const [showAddJourney, setShowAddJourney] = useState(false);
	const journeyIds = connectedJourneys.map((cj) => cj.id);
	const { openSnackbar } = useSnackbar();

	const handleChangeTags = (newJourneys: readonly string[]) => {
		const journeysOperations = determineArrayUpdateOperation(journeyIds, newJourneys);
		// Prevent firing empty update mutation
		if (journeysOperations.length === 0) {
			return;
		}

		connectJourneyToActivityAsync(
			{ activityId, data: { connectedJourneys: journeysOperations } },
			{
				onSuccess: (result) => {
					mutationResponseHandler({
						result: result.updateActivity.ok,
						toastMessages: {
							error: intl.formatMessage({ id: 'journey.detail.widget.connected-journeys.update.error' }),
						},
						errorMessage: result.updateActivity.errorMessage,
						openSnackbar,
					});
				},
			},
		);
	};

	return (
		<WidgetCell
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.tags.type}
			onMouseEnter={() => setShowAddJourney(true)}
			onMouseLeave={() => setShowAddJourney(false)}
		>
			<Stack spacing={1.5} height={'inherit'}>
				<JourneysSelect value={journeyIds} activityId={activityId} onChange={handleChangeTags} hideAdd={!showAddJourney} size={'small'} />
			</Stack>
		</WidgetCell>
	);
};
